import { PipeTransform } from '@angular/core';
import { BccService } from './../../services/bcc/bcc.service';
import { map } from 'rxjs/internal/operators';
import { localConsole } from './../../utils/local-console';
var EditMedSwitchPipe = /** @class */ (function () {
    function EditMedSwitchPipe(_bccService) {
        this._bccService = _bccService;
    }
    EditMedSwitchPipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var slotNum = '34701';
        return this._bccService.get(slotNum).pipe(map(function (bccdata) {
            var data = {};
            try {
                data = bccdata[slotNum] ? JSON.parse(atob(bccdata[slotNum])) : {};
            }
            catch (e) {
                localConsole.log(e);
            }
            if (data.order && !data.order.edit) {
                return false;
            }
            return true;
        }, function (error) {
            return true;
        }));
    };
    return EditMedSwitchPipe;
}());
export { EditMedSwitchPipe };
